/* unplugin-vue-components disabled */import { render } from "./NotificationDialog.vue?vue&type=template&id=35c196a2&scoped=true&ts=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts"

import "./NotificationDialog.vue?vue&type=style&index=0&id=35c196a2&scoped=true&lang=scss"
import "./NotificationDialog.vue?vue&type=style&index=1&id=35c196a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c196a2"]])

export default __exports__